export default function Logo({ className = "h-9", alt = "District Greenz DMV" }) {
    return <img src="/logo.webp" alt={alt} className={`${className} w-auto`} />;
}
